// extracted by mini-css-extract-plugin
export var cardColumn = "timeline-slide-module--cardColumn--ZDVwU";
export var header = "timeline-slide-module--header--sQuAP";
export var leftIndent = "timeline-slide-module--leftIndent--0RHVo";
export var quoteContainer = "timeline-slide-module--quoteContainer--hZXPf";
export var slide = "timeline-slide-module--slide--jsVTg";
export var year = "timeline-slide-module--year--kXyUT";